import {getApiList, getIdFromIri} from "@/api/backend";
import {factoryGetters, factoryMutations, factoryState} from "@/store/Modules/_factoryList";

const state = JSON.parse(JSON.stringify(factoryState));

const mutations = {
  ...factoryMutations,
};

const getters = {
  ...factoryGetters,
};

const actions = {
  async fetchList(context, {token, page}) {
    try {
      const filters = context.getters.getFilters;
      const list = (await getApiList('/newsletter-subscribers', token, {...filters, page}));

    //   const categoryIds = [];
    //   list.items.forEach(({category}) => categoryIds.push(getIdFromIri(category)));
    //   const categories = await getApiList('/product-categories', token, {id: categoryIds});

      const result = list.items.map(
        ({id, email, createdAt, updatedAt, active}) => ({
          id,
          email,
          createdAt,
          updatedAt,
          active: active ? 'TAK' : 'NIE',
        })
      );

      return context.commit('setItems', {items: result, totalItems: list.totalItems});
    } catch (e) {
      return context.commit('setApiError', {isError: true, status: e});
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
